import $ from 'jquery';
import responsive from 'lib/responsive';
import bat from 'components/bat'; // bat.hcompile
import 'isotopeVendor';
import langFromUrl from 'lib/util/langFromUrl';

var selectedLabel = langFromUrl() === 'es' ? 'Seleccionado' : 'Selected';

$(function () {
  var $container = $('.isotope-container.run-isotope');
  if ($('#grid-button').hasClass('active')) {
    $('#grid-button').attr('aria-label', $('#grid-button').attr('aria-label') + ' ' + selectedLabel);
  } else {
    $('#list-button').attr('aria-label', $('#list-button').attr('aria-label') + ' ' + selectedLabel);
  }

  /**
   * Grid Button code
   * Check if element exists or the Firebug console throws an error
   */
  var gridButton = document.getElementById('grid-button');
  if (gridButton != null && gridButton.value === '') {
    document.getElementById('grid-button').onclick = function () {
      if ($('#isotope-inventory').length) {
        $('#isotope-inventory').removeClass('list').addClass('grid');
      }

      $('#isotope-offers').removeClass('list').addClass('grid');
      $('#list-button').removeClass('active');
      $(this).addClass('active');

      let gridLabel = $(this).attr('aria-label');
      if (gridLabel.indexOf(selectedLabel) === -1) {
        $(this).attr('aria-label', gridLabel + ' ' + selectedLabel);
      }

      let listLabel = $('#list-button').attr('aria-label');
      if (listLabel.indexOf(selectedLabel) !== -1) {
        $('#list-button').attr('aria-label', listLabel.substr(0, listLabel.indexOf(selectedLabel)).trim());
      }

      // trigger custom event, for listening elsewhere, should the need arise
      // added for DataLayer (we update data-layer on this event)
      $(document).trigger('BAT.ISOTOPE_LAYOUT', { currentView: 'grid' });

      setTimeout(function () {
        $(window).smartresize();
      }, 200);
      return false;
    };
  }

  /**
   * List Button code
   * Check if element exists or the Firebug console throws an error
   */
  var listButton = document.getElementById('list-button');
  if (listButton != null && listButton.value == '') {
    document.getElementById('list-button').onclick = function () {
      if ($('#isotope-inventory').length) {
        $('#isotope-inventory').removeClass('grid').addClass('list');
        $('#isotope-inventory').height('auto');
      }

      $('#isotope-offers').removeClass('grid').addClass('list');
      $('#grid-button').removeClass('active');
      $(this).addClass('active');

      let listLabel = $(this).attr('aria-label');
      if (listLabel.indexOf(selectedLabel) === -1) {
        $(this).attr('aria-label', listLabel + ' ' + selectedLabel);
      }

      let gridLabel = $('#grid-button').attr('aria-label');
      if (gridLabel.indexOf(selectedLabel) !== -1) {
        $('#grid-button').attr('aria-label', gridLabel.substr(0, gridLabel.indexOf(selectedLabel)).trim());
      }

      // trigger custom event, for listening elsewhere, should the need arise
      // added for DataLayer (we update data-layer on this event)
      $(document).trigger('BAT.ISOTOPE_LAYOUT', { 'currentView': 'list' });

      setTimeout(function () {
        $(window).smartresize();
      }, 200);
      return false;
    };
  }

  $(window).on('breakpoint', function () {
    if ($('#inventory-vehicle').length > 0) {
      if (responsive() === 'sm') {
        $container.removeClass('list').addClass('grid');
        $('#list-button').removeClass('active');
        $('#grid-button').addClass('active');

        setTimeout(function () {
          $(window).smartresize();
        }, 200);
      }
    }
  });

  bat.SELECTED_SORT_LABEL = '';

  /* this is where the resize happens on the homepage */
  $container.isotope({
    animationEngine: 'css',
    itemSelector: '.card',
    resizable: false,

    animationOptions: {
      duration: 150,
      easing: 'linear',
      queue: false
    },

    filter: '',

    getSortData: {
      label: function ($elem) {
        if ($elem.hasClass(bat.SELECTED_SORT_LABEL)) {
          return 0;
        } else {
          return 1;
        }
      },
      price: function ($elem) {
        return $elem.data('msrp');
      }
    }
  });

  $(window).smartresize(function () {
    setTimeout(function () {
      $container.isotope();
    }, 200);
  });

  setTimeout(function () {
    $(window).smartresize();
  }, 200);

  $container.on('click', '.card .expand-button', function () {
    var $self = $(this);
    var $icon = $self.find('.icon');
    var $item = $self.closest('.card');
    var currDataLayer = $item.find('a.datalayer-link').data('anctx');
    let linkText;

    $icon.toggleClass('icon-enlarge');
    $icon.toggleClass('icon-shrink');

    if ($item.hasClass('expanded')) {
      $item.removeClass('expanded');
      linkText = 'contract';
    } else {
      $('.card').removeClass('expanded');
      $item.addClass('expanded');
      linkText = 'expand';
    }

    $self.data({
      anctx: currDataLayer,
      linktext: linkText
    });

    setTimeout(function () {
      $container.isotope();
    }, 200);
  });
});

/* ****** EXTEND ISOTOPE ******* */

$.Isotope.prototype._sort = function () {
  var sortBy = this.options.sortBy;
  var getSorter = this._getSorter;
  var sortDir = this.options.sortAscending ? 1 : -1;
  var sortFn = function (alpha, beta) {
    var a = getSorter(alpha, sortBy);
    var b = getSorter(beta, sortBy);
    // fall back to original order if data matches
    if (a === b && sortBy !== 'original-order') {
      a = getSorter(alpha, 'original-order');
      b = getSorter(beta, 'original-order');
    }
    return ((a > b) ? 1 : (a < b) ? -1 : 0) * sortDir;
  };

  this.$filteredAtoms.sort(sortFn);

  // add stamp always at 3rd position
  var index = $.inArray($('#isotope-stamp')[0], this.$filteredAtoms);
  if (index > -1) {
    var stamp = this.$filteredAtoms.splice(index, 1)[0];
    this.$filteredAtoms.splice(2, 0, stamp);
  }
};

var indexCounter = 0;

$.Isotope.prototype._pushPosition = function ($elem, x, y) {
  var containerWidth = this.element.width();
  var totalWidth = this.smallestWidth * this.masonry.cols;
  var marginToRemove = parseInt($elem.css('margin-right')) / 2;

  if (indexCounter === this.masonry.cols) { indexCounter = 0; }
  // remove all classes that begin with column
  $elem.removeClass (function (index, css) { return (css.match(/\bcolumn-\S+/g) || []).join(' '); });
  // add new column class
  $elem.addClass('column-' + (indexCounter + 1) + '-of-' + this.masonry.cols);

  x = Math.round(x + this.offset.left + (((containerWidth - totalWidth) / 2) + marginToRemove));
  y = Math.round(y + this.offset.top);
  var position = this.getPositionStyles(x, y);
  this.styleQueue.push({ $el: $elem, style: position });
  if (this.options.itemPositionDataEnabled) {
    $elem.data('isotope-item-position', { x: x, y: y });
  }

  indexCounter++;
};

$.Isotope.prototype._getSegments = function (isRows) {
  var smallestWidth = 100000000;

  // column width is based on item with largest width
  this.$filteredAtoms.each(function () {
    var itemWidth = $(this).outerWidth(true);
    if (itemWidth < smallestWidth) { smallestWidth = itemWidth; }
  });

  this.smallestWidth = smallestWidth;

  var namespace = this.options.layoutMode;
  var measure = isRows ? 'rowHeight' : 'columnWidth';
  var size = isRows ? 'height' : 'width';
  var segmentsName = isRows ? 'rows' : 'cols';
  var containerSize = this.element[size]();
  var segments;
  // i.e. options.masonry && options.masonry.columnWidth
  var segmentSize = this.options[namespace] && this.options[namespace][measure] ||
        // or use the size of the smallest item
        this.smallestWidth ||
        // if there's no items, use size of container
        containerSize;

  segments = Math.floor(containerSize / segmentSize);
  segments = Math.max(segments, 1);

  // i.e. this.masonry.cols = ....
  this[namespace][segmentsName] = segments;
  // i.e. this.masonry.columnWidth = ...
  this[namespace][measure] = segmentSize;

  indexCounter = 0;
};
